export default __webpack_public_path__ + "static/media/planet-mercury-internal.d1be1432.svg";